"use strict";
/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionAction = exports.QuestionSubType = exports.QuestionType = exports.ContentFieldType = void 0;
var ContentFieldType;
(function (ContentFieldType) {
    ContentFieldType["TEXT"] = "TEXT";
    ContentFieldType["TEXTAREA"] = "TEXTAREA";
    ContentFieldType["LIST"] = "LIST";
    ContentFieldType["COLOR"] = "COLOR";
    ContentFieldType["CSS"] = "CSS";
    ContentFieldType["IMAGE"] = "IMAGE";
    ContentFieldType["VIDEO"] = "VIDEO";
    ContentFieldType["FAVICON"] = "FAVICON";
})(ContentFieldType = exports.ContentFieldType || (exports.ContentFieldType = {}));
var QuestionType;
(function (QuestionType) {
    QuestionType["PICK_ONE"] = "PICK_ONE";
    QuestionType["PICK_MULTI"] = "PICK_MULTI";
})(QuestionType = exports.QuestionType || (exports.QuestionType = {}));
var QuestionSubType;
(function (QuestionSubType) {
    QuestionSubType["BUTTONS"] = "BUTTONS";
    QuestionSubType["SELECT"] = "SELECT";
})(QuestionSubType = exports.QuestionSubType || (exports.QuestionSubType = {}));
var OptionAction;
(function (OptionAction) {
    OptionAction["DISQUALIFY"] = "DISQUALIFY";
    OptionAction["DISQUALIFYFOR"] = "DISQUALIFYFOR";
    OptionAction["QUALIFY"] = "QUALIFY";
    OptionAction["EDUCATE"] = "EDUCATE";
    OptionAction["TORTQUALIFY"] = "TORTQUALIFY";
})(OptionAction = exports.OptionAction || (exports.OptionAction = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQVBJLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL0FQSS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsb0JBQW9CO0FBQ3BCLG9CQUFvQjtBQUNwQixtRUFBbUU7OztBQTBEbkUsSUFBWSxnQkFTWDtBQVRELFdBQVksZ0JBQWdCO0lBQzFCLGlDQUFhLENBQUE7SUFDYix5Q0FBcUIsQ0FBQTtJQUNyQixpQ0FBYSxDQUFBO0lBQ2IsbUNBQWUsQ0FBQTtJQUNmLCtCQUFXLENBQUE7SUFDWCxtQ0FBZSxDQUFBO0lBQ2YsbUNBQWUsQ0FBQTtJQUNmLHVDQUFtQixDQUFBO0FBQ3JCLENBQUMsRUFUVyxnQkFBZ0IsR0FBaEIsd0JBQWdCLEtBQWhCLHdCQUFnQixRQVMzQjtBQTBCRCxJQUFZLFlBR1g7QUFIRCxXQUFZLFlBQVk7SUFDdEIscUNBQXFCLENBQUE7SUFDckIseUNBQXlCLENBQUE7QUFDM0IsQ0FBQyxFQUhXLFlBQVksR0FBWixvQkFBWSxLQUFaLG9CQUFZLFFBR3ZCO0FBR0QsSUFBWSxlQUdYO0FBSEQsV0FBWSxlQUFlO0lBQ3pCLHNDQUFtQixDQUFBO0lBQ25CLG9DQUFpQixDQUFBO0FBQ25CLENBQUMsRUFIVyxlQUFlLEdBQWYsdUJBQWUsS0FBZix1QkFBZSxRQUcxQjtBQWdCRCxJQUFZLFlBTVg7QUFORCxXQUFZLFlBQVk7SUFDdEIseUNBQXlCLENBQUE7SUFDekIsK0NBQStCLENBQUE7SUFDL0IsbUNBQW1CLENBQUE7SUFDbkIsbUNBQW1CLENBQUE7SUFDbkIsMkNBQTJCLENBQUE7QUFDN0IsQ0FBQyxFQU5XLFlBQVksR0FBWixvQkFBWSxLQUFaLG9CQUFZLFFBTXZCIn0=